import React, { useState } from "react";
import copy_icon from "../../data/images/img-copy.png";
import { Prism as SyntaxHighlighter } from "react-syntax-highlighter";
import { coldarkDark } from "react-syntax-highlighter/dist/esm/styles/prism";
import "./css/codeview.css";
// import language from 'react-syntax-highlighter/dist/esm/languages/hljs/1c';

const CodeView = (props) => {
  const [code_lan, setCode_lan] = useState(props.data.d.cell_layout.code_lan);
  const [line_num, setLine_num] = useState(false);

  const toggle_num = () => {
    line_num ? setLine_num(false) : setLine_num(true);
  };
  const Copy_btn = () => {
    // Copy to Clipbord Button
    console.log("button Display clicked");
    var input = document.createElement("input");
    // var value  = this.state.open_topic.cells[index].source;
    var value = props.data.d.source;
    input.setAttribute("value", value);
    document.body.appendChild(input);
    input.select();
    var result = document.execCommand("copy");
    document.body.removeChild(input);
    return result;
  };

  return (
    <div className="code-view">
      <div className="code-view-top">
        <div className="code-view-lan">
          <h6>{props.data.d.cell_layout.code_lan}</h6>
        </div>
        <div className="code-view-toggle-num">
          <button
            className="btn btn-dark btn-sm code-view-toggle-num-btn"
            onClick={toggle_num.bind()}
          >
            <h6>toggle num</h6>
          </button>
        </div>
        <button className="copy_button" onClick={Copy_btn.bind()}>
          <img className="copy_icon" src={copy_icon}></img>
          {/* <span class="copy-tooltip"> Copy Code </span> */}
        </button>
      </div>
      <SyntaxHighlighter
        language={props.data.d.cell_layout.code_lan}
        style={coldarkDark}
        showLineNumbers={line_num}
      >
        {props.data.d.source}
      </SyntaxHighlighter>
    </div>
  );
};

export default CodeView;
